/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import OverFlowMenuUICss from "./OverFlowMenuUI.css";
import more from "dc-icons/consumption/s_more_18.svg";
import moreModern from "dc-icons/viewer2021/SDC_More_18_N.svg";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import * as stores from "stores";
import { getHudHandle } from "selectors/hudSelectors";
import { isSinglePageMode } from "selectors/documentSelectors";
import { getIsInPlaceMode } from "selectors/viewModeSelectors";
import { getCurrentPageIndex } from "selectors/pageNumber";
import * as constants from "constants/constants";
import { isTouchDevice } from "dc-preview-utils/src/Utils/DeviceUtils";

class OverFlowMenuUI extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.timeoutID = null;
  }

  handleClick(eventObj) {
    eventObj.stopPropagation();
    eventObj.preventDefault();
    // currently we are hardcoding contextMenu position, later we have to find a better way
    if (!this.props.isHudOverFlowMenuVisible) {
      const hudBoundingBox = getHudHandle(stores).getBoundingClientRect();
      const updatedBBox = {
        left: hudBoundingBox.left,
        right: hudBoundingBox.right,
        top: hudBoundingBox.top,
        bottom: hudBoundingBox.bottom
      };
      const xPosition = eventObj.clientX;
      let pageIdx = 0;
      if (this.props.useModernViewer) {
        if (isSinglePageMode(stores)) {
          updatedBBox.right -= constants.HUD_OVERFLOW_CONTEXTMENU_SIZED_MARGINRIGHT;
          updatedBBox.top =
            updatedBBox.top - constants.PROGRESS_BAR_HEIGHT - constants.HUD_OVERFLOW_CONTEXTMENU_SIZED_MARGINBOTTOM;
          pageIdx = getCurrentPageIndex(stores);
        } else if (getIsInPlaceMode(stores)) {
          updatedBBox.right -= constants.HUD_OVERFLOW_CONTEXTMENU_INLINE_MARGINRIGHT;
          updatedBBox.top -= constants.HUD_OVERFLOW_CONTEXTMENU_INLINE_MARGINBOTTOM;
        }
      }
      const event = {
        clientX: xPosition,
        bbox: updatedBBox,
        pageIndex: pageIdx
      };
      const contextMenuStyle = {
        backgroundColor: "#202020"
      };
      const contextMenuItemStyle = {
        color: "#FFF",
        fontSize: "12px"
      };
      let extraParams = {};
      if (!this.props.useModernViewer) {
        extraParams = {
          contextMenuStyle,
          contextMenuItemStyle
        };
      } else {
        extraParams = {
          menutItemsUsingObj: true
        };
      }
      if (isTouchDevice()) {
        extraParams.trapFocus = false;
      }
      this.props.triggerContextMenu(event, extraParams);
    } else {
      this.props.clearMenuItems();
    }
  }

  componentWillUnmount() {
    this.props.clearMenuItems();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showHUD !== this.props.showHUD && this.props.isHudOverFlowMenuVisible) {
      if (this.timeoutID) clearTimeout(this.timeoutID);
      if (!this.props.showHUD) {
        let id = setTimeout(() => {
          this.props.clearMenuItems();
        }, 2000);
        this.timeoutID = id;
      }
    }
  }

  render() {
    const className = this.props.useModernViewer ? "" : OverFlowMenuUICss.OverFlowMenu;

    return (
      <div className={className}>
        <ButtonWrapper
          icon={this.props.useModernViewer ? moreModern : more}
          clickHandler={this.handleClick}
          disabled={false}
          ariaLabel="arialabel.moreOptions"
          tooltipString="tooltip.moreOptions"
          tooltipPlacement={constants.TOOLTIP_TOP_PLACEMENT}
          tooltipDelay={constants.TOOLTIP_DELAY}
        />
      </div>
    );
  }
}

export { OverFlowMenuUI };
